'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M55.3 428l255-255 60.7 60.7-255 255-60.7-60.7z', 'M272-8l0 24 40 0 0 32-40 0 0 40-32 0 0-40-40 0 0-32 40 0 0-40 32 0 0 16zM437.4 .7L460-21.9c8.7 8.7 36.5 36.5 83.3 83.3l22.6 22.6-22.6 22.6-404.7 404.7-22.6 22.6c-8.7-8.7-36.5-36.5-83.3-83.3L10.1 428 32.7 405.4 437.4 .7zM460 23.3l-127 127 60.7 60.7 127-127-60.7-60.7zM55.3 428l60.7 60.7 255-255-60.7-60.7-255 255zM112 48l0 64 80 0 0 32-80 0 0 80-32 0 0-80-80 0 0-32 80 0 0-80 32 0 0 16zM480 304l0 80 80 0 0 32-80 0 0 80-32 0 0-80-80 0 0-32 80 0 0-80 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;